import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {Tag} from '../../../generated/graphql';
// @todo: Migrate to 'AliasGroup' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Alias} from '../../ArtifactAlias';
import {TagAddButton} from '../../TagAddButton';
import {TagType} from '../../Tags';

type ProtectedAliasesProps = {
  aliases: string[];
  onAddAlias: (tag: Tag) => Promise<void>;
  onDeleteAlias?: (alias: string) => Promise<void>;
  isViewerRegistryAdmin: boolean;
  isGlobalRegistry: boolean;
};

export const ProtectedAliases: React.FC<ProtectedAliasesProps> = ({
  aliases,
  onAddAlias,
  onDeleteAlias,
  isViewerRegistryAdmin,
  isGlobalRegistry,
}) => {
  return (
    <Tailwind>
      <div
        className={`mb-16 text-xl ${
          isGlobalRegistry ? 'font-semibold leading-8' : ''
        }`}>
        Protected Aliases
      </div>
      <div>
        Only registry admins can add or remove protected aliases from the list
        below, as well as delete registered models which contain protected
        aliases.
      </div>
      <ProtectedAliasesList
        aliases={aliases}
        onAddAlias={onAddAlias}
        onDeleteAlias={onDeleteAlias}
        isViewerRegistryAdmin={isViewerRegistryAdmin}
        isGlobalRegistry={isGlobalRegistry}
      />
    </Tailwind>
  );
};

type ProtectedAliasesListProps = {
  aliases: string[];
  onAddAlias: (tag: Tag) => Promise<void>;
  onDeleteAlias?: (alias: string) => Promise<void>;
  isViewerRegistryAdmin: boolean;
  isGlobalRegistry: boolean;
};

const ProtectedAliasesList = ({
  aliases,
  onAddAlias,
  onDeleteAlias,
  isViewerRegistryAdmin,
  isGlobalRegistry,
}: ProtectedAliasesListProps) => {
  return (
    <div className="mt-20 flex">
      <div className="min-w-[125px] font-semibold">Protected aliases:</div>
      <div className="ml-10">
        {aliases.map((alias, i) => {
          return (
            <Alias
              key={`${alias}-${i}`}
              alias={{alias}}
              onDelete={onDeleteAlias ? () => onDeleteAlias(alias) : undefined}
              onClick={() => {}}
              isProtected
              skipModal={isGlobalRegistry}
            />
          );
        })}
      </div>
      <div className="ml-10">
        {isViewerRegistryAdmin && (
          <TagAddButton
            tags={aliases.map(a => {
              return {
                name: a,
                colorIndex: TagType.PROTECTED_ALIAS,
              };
            })}
            availableTags={[]}
            addTag={onAddAlias}
            compact
            noun="alias"
            direction="center right"
          />
        )}
      </div>
    </div>
  );
};
